import PropTypes from 'prop-types';
import { FormattedMessagePropType } from './intl';

export const BulkUpdateNoteTypePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  message: FormattedMessagePropType,
  disabled: PropTypes.bool.isRequired,
});

/**
 * @typedef {object} bulkUpdateNoteType
 * @property {string} id
 * @property {JSX.Element} message should be a FormattedMessage component
 * @property {boolean} disabled
 */
